import $ from 'jquery/src/jquery';

export default () => {
    function init() {
        if (!$('a[href^="#"]').length) {
            return
        }

        initAnchor()
    }

    function initAnchor() {
        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault()
            let target = $($.attr(this, 'href')).position().top
            $("html, body").animate({ scrollTop: target }, "slow");
        });
    }

    return Object.freeze({
        init,
    })
}